/** The greeting a page opens with, by the hour on the owner's own clock. */
export function greeting(now: Date): string {
  const hour = now.getHours();
  if (hour < 5) return "夜深了";
  if (hour < 11) return "早上好";
  if (hour < 13) return "中午好";
  if (hour < 18) return "下午好";
  return "晚上好";
}
